import { createApp } from "vue";
import i18n from "../translations/i18n";
import { algoliaAppId, algoliaKeySearch } from "../algoliaSettings";
import AlgoliaSearchInput from "../../components/Algolia/AlgoliaSearchInput.vue";
import AutoComplete from "../../components/Algolia/Autocomplete/AutoComplete.vue";
import SearchResultWrapper from "../../components/Algolia/SearchResultWrapper.vue";
import AlgoliaSearchInputMobile from "../../components/Algolia/AlgoliaSearchInputMobile.vue";
import SearchResultWrapperCategory from "../../components/Algolia/SearchResultWrapperCategory.vue";
import AlgoliaRecommendations from "../../components/Algolia/AlgoliaRecommendations.vue";
import InstantSearch from "vue-instantsearch/vue3/es";

export const initializeAlgoliaAnalytics = () => {
};

export const initializeAlgoliaSearchApp = () => {
    if (!document.getElementById('js_algoliaSearch')) {
        return;
    }

    createApp({
        components: {
            SearchResultWrapper,
        }
    })
        .use(i18n)
        .mount('#js_algoliaSearch');
};

export const initializeAlgoliaSearchMobileApp = () => {
    if (!document.getElementById('js_algoliaSearchMobile')) {
        return;
    }

    createApp({
        components: {
            AlgoliaSearchInputMobile,
        }
    })
        .use(i18n)
        .mount('#js_algoliaSearchMobile');
};

export const initializeAlgoliaSearchCategoryApp = () => {
    if (!document.getElementById('js_algoliaSearchCategory')) {
        return;
    }

    createApp({
        components: { SearchResultWrapperCategory }
    })
        .use(i18n)
        .mount('#js_algoliaSearchCategory');

};

export const initializeAlgoliaRecommendationsApp = () => {
    if (!document.getElementById('js_AlgoliaRecommendations')) {
        return;
    }

    createApp({
        components: { AlgoliaRecommendations }
    })
        .use(i18n)
        .mount('#js_AlgoliaRecommendations');

};

